import axios from "axios";
import {LOGIN_API, BACK_OFFICE_API} from "../constants/apiUrls";

// 일반 로그인
export const loginApi = async (loginId, loginPw, keepCheck) => {
  const loginInfo = await axios.post(`${LOGIN_API}/login`, {
    channelType: 2,
    loginId: loginId,
    loginPassword: loginPw,
    loginDeviceType: 2,
    version: "1.1.0"
  });

  const {userId, token} = loginInfo.data;

  loginInfoSaveApi(userId, token, keepCheck);
}



// 로그인 정보 저장
export const loginInfoSaveApi = async (userId, token, keepCheck, url) => {
  const userInfo = await axios.get(`${BACK_OFFICE_API}/shop/${userId}`);
  const { shopTp, reptName } = userInfo.data[0];

  const storage = keepCheck ? window.localStorage : window.sessionStorage;

  storage.setItem("userId", userId);
  storage.setItem("token", token);
  storage.setItem("userType", shopTp);
  storage.setItem("reptName", reptName);

  if(keepCheck) {
    storage.setItem("keepChk", keepCheck)
  }

  if(url) {
    window.location.href = url;
  } else {
    window.location.href = "/v2/shopInfo1";
  }
}

// 토큰 로그인
export const tokenLoginApi = async (userId, userType, token, url) => {
  const loginInfo = await axios.post(`${LOGIN_API}/login/token`, {
    channelType: 1,
    userType: userType,
    userId: userId,
    loginDeviceType: 2,
    version: "1.0.0"
  }, {
    headers: {Authorization: `Bearer ${token}`}
  });

  const {userId: posUserId, token: posToken} = loginInfo.data;

  await tokenConvertApi(posUserId, userType, posToken, url);
}

// 토큰 전환
export const tokenConvertApi = async (userId, userType, token, url) => {
  const loginInfo = await axios.post(`${LOGIN_API}/login/token/convert`, {
    fromChannelType: 1,
    toChannelType: 2,
    userType: userType,
    userId: userId
  }, {
    headers: {Authorization: `Bearer ${token}`}
  });

  await loginInfoSaveApi(loginInfo.data.userId, loginInfo.data.token, false, url);
}

// 사업자등록번호 체크
export const getShopIdApi = async (biz) => {
  const response = await axios.get(`/orderApi/shop/check?shopBizNo=${biz}`);

  return response.data;
}

// 아이디 체크
export const getShopLoginIdApi = async (date) => {
  const response = await axios.post(`${LOGIN_API}/user/id/check`, date);

  return response.data;
}

// 비밀번호 변경
export const changePasswordApi = async (userId, date, token) => {
  await axios.put(`${LOGIN_API}/user/password/${userId}/forced`, date, {
    headers: {Authorization: `Bearer ${token}`}
  })
}


/**
 * 이하 함수는 서버 대상 식별 불가
 * 함수 내부 주석처리
 * 
 * @date 2026-04-17
 * @author Saccharin01
 */


// new 로그인
export const newLoginApi = async (data) => {
  // const response = await axios.post(`${newTestApiUrl}/ceo/sign-in`, data);

  // return response.data;
}

// new 입점신청
export const newSignUpApi = async (data) => {
  // await axios.post(`${newTestApiUrl}/ceo/sign-up`, data);
};

// new id 중복체크
export const newLoginIdCheckApi = async (data) => {
  // const response = await axios.get(`${newTestApiUrl}/ceo/auth/login-id/check`, {
  //   params: data
  // });

  // return response.data;
};

// new pw 변경
export const setPasswordApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // await axios.put(`${newTestApiUrl}/ceo/auth/password`, data, {
  //   headers: {Authorization: `Bearer ${accessToken}`}
  // });
};

// 토큰 로그인
export const newTokenLoginApi = async (token, data) => {
  // const response = await axios.post(`${newTestApiUrl}/ceo/sign-in/token`, data, {
  //   headers: {Authorization: `Bearer ${token}`}
  // });

  // return response.data;
};

// 휴대폰 인증번호 전송
export const authCertApi = async (tel) => {
  // await axios.post(`${newTestApiUrl}/ceo/auth/cert`, {
  //   tel: tel
  // });
}

// 문자인증
export const authCertCheckApi = async (loginId, tel, code) => {
  // const response = await axios.post(`${newTestApiUrl}/ceo/auth/cert/check`, {
  //   loginId: loginId,
  //   tel: tel,
  //   certNo: code
  // });

  // return response.data;
}

// 아이디 체크
export const authLoginIdCheckApi = async (bizNo) => {
  // const response = await axios.get(`${newTestApiUrl}/ceo/auth/biz-no/check`, {
  //   params: {bizNo: bizNo}
  // });

  // return response.data;
}

// 비밀번호 변경
export const authPasswordResetApi = async (password, token) => {
  // await axios.put(`${newTestApiUrl}/ceo/auth/password/reset`, {
  //   newPassword: password
  // }, {
  //   headers: {
  //     'X-Modify-Password-Token': token
  //   }
  // });
}